import { Link, useLocation } from "react-router-dom";
import React from "react";
import { useTranslation } from "react-i18next";
import BGIMG from "../../assets/img/bg/bdrc-bg.png";
import { routeMeta, getMeta } from "../../seo/routeMeta.mjs";
import { routeForSlug } from "../../i18n/lang.mjs";

const Bredcrumb = ({ title, subtitle }) => {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();

  // The breadcrumb heading is the page's single <h1>. Use the canonical,
  // keyword-optimized H1 from routeMeta when available (per active language),
  // otherwise fall back to the title prop passed by the page.
  const route = routeForSlug(pathname);
  const lang = ["sr", "en", "de"].includes(i18n.language) ? i18n.language : "sr";
  const h1Text = routeMeta[route] ? getMeta(route, lang).h1 : title;

  return (
    <>
      <section
        className="breadcrumb-area d-flex align-items-center"
        style={{
          backgroundImage: `url(${BGIMG})`,
          paddingTop: "72px",
        }}
      >
        <div className="container" style={{ position: "relative", zIndex: 1 }}>
          <div className="row align-items-center">
            <div className="col-xl-12 col-lg-12">
              <div className="breadcrumb-wrap text-left">
                <div className="breadcrumb-title">
                  <h1
                    style={{
                      fontFamily: "'Cormorant Garamond', 'PT Serif', serif",
                      color: "#FAF7F2",
                      fontSize: "clamp(2.8rem, 6vw, 5rem)",
                      fontWeight: "600",
                      letterSpacing: "0.02em",
                      textShadow: "0 2px 24px rgba(0,0,0,0.20)",
                      marginBottom: "16px",
                      lineHeight: "1.1",
                    }}
                  >
                    {h1Text}
                  </h1>
                  <div className="breadcrumb-wrap">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link
                            to="/"
                            style={{
                              color: "rgba(255,255,255,0.82)",
                              fontFamily: "'Inter', sans-serif",
                              fontSize: "14px",
                              letterSpacing: "0.04em",
                              textDecoration: "none",
                              transition: "color 0.25s ease",
                            }}
                          >
                            {t('breadcrumb.home')}
                          </Link>
                        </li>
                        <li
                          className="breadcrumb-item active"
                          aria-current="page"
                          style={{
                            color: "rgba(255,255,255,0.58)",
                            fontFamily: "'Inter', sans-serif",
                            fontSize: "14px",
                            letterSpacing: "0.04em",
                          }}
                        >
                          {subtitle}
                        </li>
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Bredcrumb;
